var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_vm._t("default",null,{"selectedOption":_vm.selectedOption,"orientation":_vm.orientation,"id":_vm.id})],2)}
var staticRenderFns = []

export { render, staticRenderFns }